/* eslint-disable import/extensions */

// Services Img Imports

import Dataanalysis from '../assets/images/Portfolio/wishlist.webp';
import Marketing from '../assets/images/Portfolio/goals.jpg';
import Contact from '../assets/images/Portfolio/dream.jpg';
import Salesai from '../assets/images/Portfolio/feedback.webp';
import Projects from '../assets/images/Portfolio/sport.jpg';
import Achieve from '../assets/images/Portfolio/achieve.jpg';

// Portfolio Img Imports
import Recruiting from '../assets/images/Portfolio/marketing.png';
import Stream from '../assets/images/Portfolio/sales2.png';
import Freelance from '../assets/images/Portfolio/hrm.png';
import Aura from '../assets/images/Portfolio/facturatie.png';
import Surtido from '../assets/images/Portfolio/sales.png';
import ManagementApp from '../assets/images/Portfolio/research.png';
import Website from '../assets/images/Portfolio/website.png';

import PM from '../assets/images/Portfolio/pm.png';
import Resources from '../assets/images/Portfolio/resource.png';
import Dataa from '../assets/images/Portfolio/dataa.png';

// Advantages
import Communicative from '../assets/images/Advantages/Communicative.png';
import Collaborative from '../assets/images/Advantages/Collaborative.png';
import Management from '../assets/images/Advantages/Management.png';
import Favorite from '../assets/images/Advantages/Favorite.png';

// Testimonials
import KBC from '../assets/images/Testimonials/comongent.png';
import Google from '../assets/images/Testimonials/180degrees.png';
import Finplex from '../assets/images/Testimonials/imec-istart-logo-pos.avif';
// TeamMembers
import Stijn from '../assets/images/TeamMembers/stijn.jpg';
import Yorin from '../assets/images/TeamMembers/yorin.png';
import Jacob from '../assets/images/TeamMembers/Jacob.jpg';

export const Services = [
  {
    title: 'Bepaal zelf je droom',
    imageUrl: Dataanalysis,
    animation: 'left',
  },
  {
    title: 'Krijg duidelijke stappen om je droom te bereiken',
    imageUrl: Marketing,
    animation: 'up',
  },
  {
    title: 'Bijgestaan door een coach',
    imageUrl: Contact,
    animation: 'right',
  },
  {
    title: 'Gepersonaliseerd mentaal & fysiek schema',
    imageUrl: Salesai,
    animation: 'left',
  },
  {
    title: 'Ondersteuning door wetenschappelijk onderzoek',
    imageUrl: Projects,
    animation: 'up',
  },
  {
    title: 'Bereik je dromen!',
    imageUrl: Achieve,
    animation: 'down',
  },
];

export const Blogs = [
  {
    id: 'bvf1293uasdads1',
    title: 'Onze nieuwe website is live!',
    imageUrl: Website,
    type: 'Nieuws',
    responsibility: [
      'Nieuws',
    ],
    text: "We zijn verheugd om de lancering van de website voor RevOnc aan te kondigen, de nieuwe app speciaal ontwikkeld voor kankerpatiënten na hun behandeling. Deze innovatieve app stelt gebruikers in staat hun beweegdromen te realiseren en ondersteunt hen op weg naar een actieve, gezonde toekomst. De website biedt een helder overzicht van wat RevOnc te bieden heeft. Van persoonlijke doelen stellen tot toegang tot beweegprogramma’s op maat, ReVonc combineert wetenschappelijke inzichten met praktische ondersteuning. Daarnaast fungeert de app als een inspiratiebron, met succesverhalen van andere gebruikers en adviezen van experts om gemotiveerd te blijven. RevOnc richt zich op het empoweren van kankerpatiënten door hen de tools te bieden die ze nodig hebben om hun kwaliteit van leven te verbeteren na een intensieve behandelingsperiode. Onze website biedt uitgebreide informatie over de functionaliteiten van de app, samen met inspirerende verhalen van gebruikers die hun beweegdromen al hebben waargemaakt. We nodigen je uit om onze nieuwe website te verkennen en meer te ontdekken over hoe RevOnc kan helpen jouw beweegdromen werkelijkheid te maken. Voor meer informatie of om direct te beginnen, kun je eenvoudig contact met ons opnemen via de site. Samen zetten we stappen naar een gezonde, actieve toekomst waarin dromen mogelijk worden. Ontdek vandaag nog RevOnc en laat je inspireren!",
    credit: 'https://dribbble.com/shots/15164950-Recruiting-app',
  },
];

export const Portfolios = [
  {
    id: 'asd1293uasdads1',
    title: 'Marketing',
    imageUrl: Recruiting,
    type: 'AI',
    responsibility: [
      'AI',
    ],
    text: "Met deze applicatie kunt u moeiteloos uw marketingcampagnes beheren op verschillende platforms, met krachtige AI-ondersteuning. U kunt uitgebreide campagnes ontwikkelen en verrijken met inzichten en strategieën, terwijl de creatieve suite u helpt om aantrekkelijke afbeeldingen, audio en video's te genereren. Ook kunt u effectieve marketing-e-mails samenstellen en SEO-geoptimaliseerde blogs schrijven die zijn afgestemd op uw doelgroep. De applicatie ondersteunt u bovendien bij het maken van berichten voor LinkedIn, Facebook, Instagram en TikTok, zodat u moeiteloos boeiende content kunt creëren voor elk platform. Daarnaast biedt de applicatie SEO-trefwoordsuggesties om de zichtbaarheid in zoekmachines te verbeteren en kunt u gebruikmaken van AI-gedreven concurrentieanalyse voor waardevolle marktinzichten. Selecteer eenvoudig een tabblad om te beginnen en ontdek alle functies in detail.",
    credit: 'https://dribbble.com/shots/15164950-Recruiting-app',
  },
  {
    id: 'asd1293uhjkhkjh2',
    title: 'Financiële voorspellingen',
    imageUrl: Stream,
    type: 'Beheer',
    responsibility: [
      'Beheer',
    ],
    text: "Stel je een dashboard voor dat al je bedrijfskritische inzichten, concurrentie-intelligentie en SEO-meesterschap onder één dak brengt. Je bent hier niet alleen om data te observeren; je bent hier om actie te ondernemen, beslissingen te nemen en voorop te blijven lopen. Hier is een voorproefje van wat elk tabblad voor je kan ontketenen: Bedrijfsprofiel: Duik diep in de hartslag van uw bedrijf met realtime financiële data, machine learning-inzichten en stakeholdersnapshots. Bekijk patronen, detecteer anomalieën en maak gebruik van AI om een stap voor te blijven. SEO-meesterschap: Klaar om te stijgen in de zoekresultaten? Analyseer de trefwoorden, contentstructuur en prestatievoorspellingen van uw site. Krijg AI-gestuurde inzichten om uw SEO-strategie te optimaliseren en uw concurrenten te overtreffen. Impact van sociale media: Houd de vinger aan de pols van de sociale voetafdruk van uw merk. Schraap gegevens van platforms zoals Facebook en LinkedIn, analyseer betrokkenheid en gebruik inzichten om uw digitale aanwezigheid te versterken. Concurrentieanalyse: Versla de concurrentie door hun zwakheden te begrijpen en kansen te benutten. Vergelijk financiën, online strategieën en invloeden van belanghebbenden om uw voorsprong in de markt te vergroten. Of u nu uw bedrijfsvoering wilt stroomlijnen, uw SEO wilt optimaliseren of de overhand wilt krijgen in uw branche, dit dashboard is uw toegangspoort tot slimmere, snellere en meer daadkrachtige bedrijfsgroei.",
    credit: 'https://dribbble.com/shots/15276430-Stream',
  },
  {
    id: 'asd1293uvbvcbbd3',
    title: 'HRM',
    imageUrl: Freelance,
    type: 'Management',
    responsibility: [
      'Management',
    ],
    text: "In het platform kan je op een eenvoudige manier aan personeelsbeheer doen met prestatiemanagement, verlofplanning en het matchen van de juiste profielen met de juiste vacatures.",
    credit: 'https://dribbble.com/shots/15223131-Freelance-Mobile-App-Concept',
  },
  {
    id: 'asd1293ufgdfgs4',
    title: 'Facturatie',
    imageUrl: Aura,
    type: 'Management',
    responsibility: [
      'Management',
    ],
    text: "Binnen in ons facturatieplatform kan je snel inkomende en uitgaande facturen opvolgen, inzichten verwerven en natuurlijk via PEPPOL tewerk gaan",
    credit: 'https://dribbble.com/shots/15176338-Aura-Website-Main-Page',
  },
  {
    id: 'asd1293ulskmnb5',
    title: 'Sales',
    imageUrl: Surtido,
    type: 'Beheer',
    responsibility: [
      'Beheer',
    ],
    text: "Welkom in de toekomst van verkoop met AI! Stel je voor dat je beschikt over een virtuele verkoopassistent die niet alleen inzichten kan genereren en je pitch kan verbeteren, maar ook prijzen kan berekenen. De ultieme verkooptoolkit is hier, ontworpen om elke stap van het verkoopproces soepel, strategisch en zeer succesvol te maken. Met AI sluit je deals sneller dan ooit. Met deze tool genereer je moeiteloos hoogwaardige verkoopinhoud die impact maakt. Of het nu gaat om blogposts, sociale media berichten of productbeschrijvingen, onze AI creëert op conversie gerichte teksten die perfect zijn afgestemd op je doelgroep. Daarnaast kun je in enkele minuten prachtige, overtuigende pitch decks samenstellen. Of je nu investeerders wilt aantrekken of een deal wilt sluiten met een klant, de pitch deck generator helpt je visueel aantrekkelijke presentaties te maken die gegarandeerd de deal bezegelen. Bereid je voor om een meester in je pitch te worden met onze AI-ondersteunde pitch trainer. Deze tool geeft realtime feedback en helpt je om je vaardigheden te verbeteren, zodat je elke vergadering vol vertrouwen ingaat. Als je klanten wilt verbluffen met scherpe inzichten, hoef je alleen maar je vraag in te voeren; onze AI levert je direct realtime analyses en waardevolle inzichten die je helpen strategischere beslissingen te nemen. Prijzen vaststellen is eenvoudig met onze prijscalculator, die je helpt de optimale prijs voor elke deal te bepalen, zodat je geen geld laat liggen. Bovendien maakt de Meeting Scheduler het eenvoudig om afspraken, follow-ups en consultaties in te plannen, zodat je geen enkele kans mist.Stop met dromen van succes en laat het werkelijkheid worden. Gebruik de kracht van AI om je verkoopproces te transformeren en sneller deals te sluiten dan ooit tevoren.",
    credit: 'https://dribbble.com/shots/15173118-Surtido-Rico',
  },
  {
    id: 'asd1293ulkmnbj6',
    title: 'AI-driven Research',
    imageUrl: ManagementApp,
    type: 'Beheer',
    responsibility: [
      'Beheer',
    ],
    text: "Door middel van onze generatieve AI kan je diepere inzichten verwerven in welke volgende stappen je kan nemen als onderneming om verder te kunnen groeien op een positieve manier",
    credit: 'https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App',
  },
  {
    id: 'asd1293ulguyrbj6',
    title: 'Project Management',
    imageUrl: PM,
    type: 'Management',
    responsibility: [
      'Management',
    ],
    text: "Beheer je projecten op een eenvoudige manier maar hou toch je kosten onder controle. Je haalt elke deadline, kan taken eenvoudig overzien en dit alles binnen hetzelfde kader",
    credit: 'https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App',
  },
  {
    id: 'asd1789ulkmnbj6',
    title: 'Resource Management',
    imageUrl: Resources,
    type: 'Beheer',
    responsibility: [
      'Beheer',
    ],
    text: "Zie in een opslag welke projecten er lopen, wie welke uren boekt, en welke van je bedrijfsmiddelen geboekt zijn in ons platform",
    credit: 'https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App',
  },
  {
    id: 'asd129455kmnbj6',
    title: 'Data analysis',
    imageUrl: Dataa,
    type: 'AI',
    responsibility: [
      'AI',
    ],
    text: "Stel je een dashboard voor dat al je bedrijfskritische inzichten, concurrentie-intelligentie en SEO-meesterschap onder één dak brengt. Je bent hier niet alleen om data te observeren; je bent hier om actie te ondernemen, beslissingen te nemen en voorop te blijven lopen. Hier is een voorproefje van wat elk tabblad voor je kan ontketenen: Bedrijfsprofiel: Duik diep in de hartslag van uw bedrijf met realtime financiële data, machine learning-inzichten en stakeholdersnapshots. Bekijk patronen, detecteer anomalieën en maak gebruik van AI om een stap voor te blijven. SEO-meesterschap: Klaar om te stijgen in de zoekresultaten? Analyseer de trefwoorden, contentstructuur en prestatievoorspellingen van uw site. Krijg AI-gestuurde inzichten om uw SEO-strategie te optimaliseren en uw concurrenten te overtreffen. Impact van sociale media: Houd de vinger aan de pols van de sociale voetafdruk van uw merk. Schraap gegevens van platforms zoals Facebook en LinkedIn, analyseer betrokkenheid en gebruik inzichten om uw digitale aanwezigheid te versterken. Concurrentieanalyse: Versla de concurrentie door hun zwakheden te begrijpen en kansen te benutten. Vergelijk financiën, online strategieën en invloeden van belanghebbenden om uw voorsprong in de markt te vergroten. Of u nu uw bedrijfsvoering wilt stroomlijnen, uw SEO wilt optimaliseren of de overhand wilt krijgen in uw branche, dit dashboard is uw toegangspoort tot slimmere, snellere en meer daadkrachtige bedrijfsgroei.",
    credit: 'https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App',
  },
];

export const Advantages = [
  [{
    title: 'Innovatief',
    description: 'Een app die je echt helpt met elke stap richting je dromen',
    imageUrl: Favorite,
  },
  {
    title: 'Kwaliteit',
    description: 'Een app met ondersteuning van wetenschappelijke kennis in een persoonlijk schema',
    imageUrl: Communicative,
  },
  {
    title: 'Eenvoud',
    description: 'In enkele stappen is je traject meteen duidelijk, op een toegankelijke manier',
    imageUrl: Management,
  }],
  [{
    title: 'Sociaal',
    description: 'RevOnc zet in op echte ervaringen die relevant zijn voor jou waarbij contact met lotgenoten mogelijk is',
    imageUrl: Collaborative,
  },
  {
    title: 'Expertise',
    description: 'Een applicatie die ondersteund wordt door experten',
    imageUrl: Favorite,
  }],
];
export const Testimonials = [
  {
    id: 1,
    name: 'Comon.Gent',
    company: 'Comon.Gent',
    testimoni: 'Comon werkt momenteel rond de uitdaging ‘Hoe kunnen we bewegen doorheen de stad plezieriger maken?',
    imageUrl: KBC,
  },
  {
    id: 2,
    name: '180 Degrees Consulting',
    company: '180 Degrees Consulting',
    testimoni: 'Een student-gedreven consultancy, deel van de UGent',
    imageUrl: Google,
  },
  {
    id: 3,
    name: 'Imec.Istart Launch Programme',
    company: 'Imec.Istart Launch Programme',
    testimoni: 'Het Imec.Istart programma laat start-ups toe zich snel te ontwikkelen',
    imageUrl: Finplex,
  },
];

export const TeamMembers = [
  {
    name: 'Yorin De Smet',
    position: 'Oprichter',
    imageUrl: Yorin,
  },
  {
    name: 'Stijn Van Hijfte',
    position: 'Mede-oprichter',
    imageUrl: Stijn,
  },
  {
    name: 'Jacob Deforce',
    position: 'It Magician',
    imageUrl: Jacob,
  },

];
